var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-wrapper"},[_c('div',{ref:"print",attrs:{"id":"print"}},[_vm._t("default")],2),_c('div',{ref:"printSwap",attrs:{"id":"print-swap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }